import { LegacyRef, forwardRef } from "react";
import {
  ContextProvider,
  RenderFn,
} from "./model/localized-value-control-context";
import { FormItemProps, InputRef } from "antd";
import { ShortView } from "./ui/short-view";
import { FullView } from "./ui/full-view";
import { Modal, ModalProps } from "@/shared/modal";
import Button from "../button";
import { Rule } from "../form";
import { useTranslations } from "use-intl";

export type LocalizedValueProps = FormItemProps & {
  myLocaleRules?: Rule[];
  render: RenderFn;
  modalProps?: ModalProps;
  translationContext?: string;
};

export const LocalizedValue = forwardRef(function LocalizedValue(
  props: LocalizedValueProps,
  ref: LegacyRef<InputRef>,
) {
  const {
    render,
    myLocaleRules,
    modalProps,
    translationContext,
    ...formItemProps
  } = props;
  const t = useTranslations("LocalizedValue");

  return (
    <ContextProvider
      inputRef={ref}
      render={render}
      formItemProps={formItemProps}
      myLocaleRules={myLocaleRules}
      translationContext={translationContext}
    >
      {(isOpen, close) => (
        <>
          <ShortView />
          {isOpen && (
            <Modal
              open={isOpen}
              onCancel={close}
              title={t("Translations")}
              {...modalProps}
            >
              <FullView />
              <div className="flex justify-end">
                <Button onClick={close} type="primary">
                  {t("Close")}
                </Button>
              </div>
            </Modal>
          )}
        </>
      )}
    </ContextProvider>
  );
});
